<div mat-dialog-content>

  <h2 *ngIf="status === '月初処理中'">当月の運用開始前に必要な情報を入力してください</h2>
  <h2 *ngIf="status === '月末処理中'">月末処理に必要な情報を入力してください</h2>

  <table>
    <tr>
      <th>login</th><td>{{report.login_user_id}}</td>
      <th>氏名</th><td>{{report.user_name}}</td>
    </tr>
    <tr>
      <th>POOL</th><td>{{getPool(report.cap_id)}}</td>
      <th>口座番号</th><td>{{report.cap_id}}</td>
    </tr>
    <tr>
      <th>前月末残高（{{report.cur}}）</th>
      <td>{{report.bal_a | number:'1.8-8'}}</td>
      <th>月末残高（{{report.cur}}）</th>
      <td>{{report.bal_b | number:'1.8-8'}}</td>
    </tr>
  </table>

  <table>
    <tr><th>項目</th><th>値</th><th>入力エラー・備考など</th></tr>

    <ng-container *ngIf="status === '月初処理中' || status === '月末処理中' || isRebuildMode">

      <tr>
          <th>成功報酬料率 (%)</th>
          <td><app-decimal-input [asPercent]="true" [scale]="4" [(ngModel)]="report.hdc" [positiveOnly]="true"></app-decimal-input></td>
          <td><span [ngClass]="{'error': !isHdcValid}">必ず０％以上の数値を入力してください</span></td>
      </tr>

      <tr>
        <th>管理手数料率 (%)</th>
        <td><app-decimal-input [asPercent]="true" [scale]="4" [(ngModel)]="report.monthly_management_fee" [positiveOnly]="true"></app-decimal-input></td>
        <td>未入力の場合は０％扱いになります</td>
      </tr>

    </ng-container>

    <ng-container *ngIf="status === '月初処理中' || isRebuildMode">

      <tr>
        <th>調整額（{{report.cur}}）</th>
        <td><app-decimal-input [(ngModel)]="report.adjust_amount" [scale]="8" [readonly]="isAmountLocked"></app-decimal-input></td>
        <td><span [ngClass]="{'error': !isAdjustValid}">入力した場合はコメントも入力してください</span></td>
      </tr>

      <tr>
        <th><span [ngClass]="{'error': !isAdjustValid}">調整コメント</span></th>
        <td colspan="2"><input type="text" [(ngModel)]="report.adjust_comment" style="width: 96%;"></td>
      </tr>
    </ng-container>


    <ng-container *ngIf="status === '月末処理中' || isRebuildMode">
      <tr>
        <th>その他手数料（{{report.cur}}）</th>
        <td><app-decimal-input [(ngModel)]="report.hc_b" [positiveOnly]="true" [scale]="8" [readonly]="isAmountLocked"></app-decimal-input></td>
        <td><span [ngClass]="{'error': !isHcbValid}">入力した場合はコメントも入力してください</span></td>
      </tr>

      <tr>
        <th><span [ngClass]="{'error': !isHcbValid}">その他手数料コメント</span></th>
        <td colspan="2"><input type="text" [(ngModel)]="report.hc_b_comment" style="width: 96%;"></td>
      </tr>

      <tr>
        <th>年金用出金額（{{report.cur}}）</th>
        <td><app-decimal-input [(ngModel)]="report.pension" [positiveOnly]="true" [scale]="8" [readonly]="isAmountLocked"></app-decimal-input></td>
        <td></td>
      </tr>

      <tr>
        <th>出金額（{{report.cur}}）</th>
        <td><app-decimal-input [(ngModel)]="report.shukkin" [positiveOnly]="true" [scale]="8" [readonly]="isAmountLocked"></app-decimal-input></td>
        <td>
          <mat-checkbox [(ngModel)]="report.is_full_withdrawal" (change)="onFullWithdrawalChange($event)" [disabled]="report.is_full_transfer">全額出金</mat-checkbox>
        </td>
      </tr>

      <tr>
        <th>振替先POOL</th>
        <td>
          <mat-select [(ngModel)]="report.transfer_pool">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let obj of PoolTypeMap" [value]="obj.pool">{{ obj.pool }}</mat-option>
          </mat-select>
        </td>
        <td><span [ngClass]="{'error': !isTransferPoolValid}">選択した場合は振替額も入力してください</span></td>
      </tr>

      <tr>
        <th><span [ngClass]="{'error': !isTransferPoolValid}">振替額（{{report.cur}}）</span></th>
        <td><app-decimal-input [(ngModel)]="report.transfer_amount" [positiveOnly]="true" [scale]="8" [readonly]="isAmountLocked"></app-decimal-input></td>
        <td>
          <mat-checkbox [(ngModel)]="report.is_full_transfer" (change)="onFullTransferChange($event)" [disabled]="report.is_full_withdrawal">全額振替</mat-checkbox>
        </td>
      </tr>

      <tr>
          <th>振替後の成功報酬料率 (%)</th>
          <td><app-decimal-input [asPercent]="true" [scale]="4" [(ngModel)]="report.transfer_hdc" [positiveOnly]="true"></app-decimal-input></td>
          <td><span [ngClass]="{'error': !isTransferPoolValid}">必ず０％以上の数値を入力してください</span></td>
      </tr>

      <tr>
        <th>振替後のこの口座に関する備考</th>
        <td colspan="2"><textarea [(ngModel)]="report.transfer_note" style="width: 98%;" rows="3"></textarea></td>
      </tr>

      <tr>
        <th>概算の最終月末残高（{{report.cur}}）</th>
        <td><span [ngClass]="{'error': isNegativeEstimate}" style="font-size: 13px;">{{estimate | number:'1.8-8'}}</span></td>
        <td><span [ngClass]="{'error': isNegativeEstimate}">マイナスにならないようにしてください</span></td>
      </tr>

    </ng-container>

    <tr *ngIf="isAmountLocked"><td colspan="3" style="text-align: center; color: red;">「全額出金」・「全額振替」チェックボックスが選択されたので、金額関係の入力欄はロックされました。</td></tr>
    <tr><td colspan="3" style="text-align: center;">以下の項目は必要に応じて更新してください</td></tr>

    <tr>
      <th>JACは共同口座</th>
      <td><input type="text" [(ngModel)]="report.flg"></td>
      <td><span [ngClass]="{'error': !isFlgValid}">「JAC」（半角）のみ入力可能</span></td>
    </tr>

    <tr>
      <th><span [ngClass]="{'error': !isCmmValid}">共同名義者名（JACには必須）</span></th>
      <td colspan="2"><input type="text" [(ngModel)]="report.cmm" style="width: 96%;"></td>
    </tr>

    <tr>
      <th>運用開始・拘束期間・終了日</th>
      <td colspan="2">
        <input type="date" [(ngModel)]="report.enroll" (blur)="calcChg()"> 開始
        <input type="number" [(ngModel)]="report.res_b" (blur)="calcChg()" style="margin-left: 1em; width: 4em;"> ヶ月
        <input type="date" [(ngModel)]="report.chg" style="margin-left: 1em;" readpnly> まで拘束
      </td>
    </tr>

    <tr>
      <th>この口座に関する備考</th>
      <td colspan="2"><textarea [(ngModel)]="report.note" style="width: 98%;" rows="3"></textarea></td>
    </tr>

  </table>

  <div mat-dialog-actions align="end">
    <div style="position: absolute; left: 0;">
      <mat-checkbox [(ngModel)]="isRebuildMode" [disabled]="saving">個別口座の履歴再構築モード</mat-checkbox>
    </div>

    <button mat-button (click)="onCancel()" [disabled]="saving">
      キャンセル
    </button>
    <button mat-raised-button color="primary"
            (click)="onSave()"
            [disabled]="saving || !isValid || isNegativeEstimate">
      {{ saving ? '保存中...' : (isRebuildMode ? '当月以降の履歴を全更新' : '保存') }}
    </button>

</div>
